// extracted by mini-css-extract-plugin
module.exports = {"userBox":"userBubble_userBox__l2st7","info":"userBubble_info__z8wTP","tick":"userBubble_tick__NoR5d","date":"userBubble_date__8Wj6_"};